import { Image } from "lucide-react";
import { FC } from "react";

import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  src?: string;
  alt?: string;
  srcSetWidths?: Array<SrcSetWidth>;
};

// these are defined in Cloudflare image transforms
// the width are also the paths of the transform urls
export type SrcSetWidth = 200 | 400 | 800 | 1200 | 1600 | 2000 | 3000 | 4000;

const CLOUDFLARE_IMAGE_CDN = "imagedelivery.net";

export const SkuImage: FC<Props> = ({
  src,
  alt,
  className,
  srcSetWidths,
  ...props
}) => {
  if (!src) {
    return (
      <div
        className={cn(
          "rounded-lg flex justify-center items-center bg-gray-100 aspect-square",
          className,
        )}
      >
        <Image className="size-6 text-gray-500" />
      </div>
    );
  }

  return (
    <div className={cn("rounded-lg overflow-hidden", className)}>
      <img
        className="size-full object-cover aspect-square"
        src={src}
        srcSet={
          src.includes(CLOUDFLARE_IMAGE_CDN)
            ? getCloudflareSourceSet(src, srcSetWidths)
            : undefined
        }
        {...props}
        alt={alt}
      />
    </div>
  );
};

const defaultSrcSetWidths = [200, 400, 800, 1200, 1600, 2000, 3000, 4000];

const getCloudflareImgByWidth = (src: string, width: number) => {
  return `${src.replace("public", "")}${width}`;
};

const getCloudflareSourceSet = (
  src: string,
  srcSetWidths?: Array<SrcSetWidth>,
) => {
  const widths = srcSetWidths ?? defaultSrcSetWidths;

  return widths
    .map((width) => `${getCloudflareImgByWidth(src, width)} ${width}w`)
    .join(", ");
};
